import React, { useState } from "react";
import { Download, FileSpreadsheet, FileText } from "lucide-react";
import { downloadExport } from "@/lib/adminApi";
import { toast } from "sonner";

export default function AdminExports() {
  const [loading, setLoading] = useState(null);
  const go = async (kind) => {
    setLoading(kind);
    try {
      await downloadExport(kind);
      toast.success(`Exportação ${kind.toUpperCase()} baixada`);
    } catch (e) {
      toast.error("Erro ao exportar");
    } finally {
      setLoading(null);
    }
  };

  return (
    <div data-testid="admin-exports-page">
      <div className="hub-eyebrow">Exportações</div>
      <h1 className="mt-2 font-display font-medium text-3xl sm:text-4xl tracking-tight">
        Baixar base de diagnósticos
      </h1>
      <p className="mt-2 text-slate-600 max-w-2xl">
        Exporte a base completa de diagnósticos com pontuação por pilar, status
        comercial, observações e histórico de atualização — em Excel ou CSV.
      </p>

      <div className="mt-10 grid md:grid-cols-2 gap-5 max-w-3xl">
        <div className="hub-card p-8">
          <div className="w-11 h-11 rounded-xl bg-[#0F172A] text-white grid place-items-center">
            <FileSpreadsheet size={20} />
          </div>
          <div className="mt-5 font-display font-medium text-xl">
            Exportar Excel
          </div>
          <div className="mt-1 text-sm text-slate-600">
            Planilha .xlsx com cabeçalho estilizado e uma linha por diagnóstico.
          </div>
          <button
            data-testid="btn-export-xlsx"
            onClick={() => go("xlsx")}
            className="hub-btn-primary mt-6"
            disabled={loading === "xlsx"}
          >
            <Download size={14} /> {loading === "xlsx" ? "Preparando…" : "Baixar .xlsx"}
          </button>
        </div>

        <div className="hub-card p-8">
          <div className="w-11 h-11 rounded-xl bg-[#D97706] text-white grid place-items-center">
            <FileText size={20} />
          </div>
          <div className="mt-5 font-display font-medium text-xl">
            Exportar CSV
          </div>
          <div className="mt-1 text-sm text-slate-600">
            Arquivo .csv com BOM UTF-8 (abre corretamente no Excel PT-BR).
          </div>
          <button
            data-testid="btn-export-csv"
            onClick={() => go("csv")}
            className="hub-btn-secondary mt-6"
            disabled={loading === "csv"}
          >
            <Download size={14} /> {loading === "csv" ? "Preparando…" : "Baixar .csv"}
          </button>
        </div>
      </div>

      <div className="mt-10 hub-card p-6 max-w-3xl">
        <div className="hub-eyebrow">Colunas exportadas</div>
        <div className="mt-3 grid sm:grid-cols-2 gap-x-6 gap-y-1 text-sm text-slate-700">
          <div>• Empresa</div>
          <div>• Responsável / Cargo</div>
          <div>• E-mail / Telefone</div>
          <div>• Cidade / Estado</div>
          <div>• Segmento</div>
          <div>• Colaboradores</div>
          <div>• Índice HUB</div>
          <div>• Classificação</div>
          <div>• Pontuação dos 7 pilares</div>
          <div>• Status Comercial</div>
          <div>• Sessão Estratégica</div>
          <div>• Observações</div>
          <div>• Última Atualização</div>
          <div>• Data do Diagnóstico</div>
        </div>
      </div>
    </div>
  );
}
